module.exports = __webpack_public_path__ + "static/media/2.11.7626621e.png";